import {API_URLS} from '@/const';
import {http} from '@/helper';

export const kolApi = {
  getRebateRecordList(query) {
    return http.get(API_URLS.REBATE_RECORD_LIST, {query});
  },
  getRebateDetailList(query) {
    return http.get(API_URLS.REBATE_DETAIL_LIST, {query});
  },
  getUserDetailList(query) {
    return http.get(API_URLS.USER_DETAIL_LIST, {query});
  },
  getAgentDetailList(query) {
    return http.get(API_URLS.AGENT_DETAIL_LIST, {query});
  },
  getWalletRecordList(query) {
    return http.get(API_URLS.WALLET_RECORD_LIST, {query});
  },
  getAgentInfo(query) {
    return http.get(API_URLS.AGENT_INFO, {query});
  },
  getAllGroup(query) {
    return http.get(API_URLS.ALL_GROUP, {query});
  },
  getGroupList(query) {
    return http.get(API_URLS.GROUP_LIST, {query});
  },
  getBalance(query) {
    return http.get(API_URLS.BALANCE, {query});
  },
  getSummary(query) {
    return http.get(API_URLS.WALLET_SUMMARY, {query});
  },
  withdrawAll(query) {
    return http.put(API_URLS.WITHDRAW_ALL, {query});
  },
  updateWithdraw(params) {
    return http.put(API_URLS.WITHDRAW, {params});
  },
  addGroup(params) {
    return http.post(API_URLS.ADD_GROUP, {params});
  },
  updateCashbackRate(params) {
    return http.put(API_URLS.AGENT_CASHBACK_RATE, {params});
  },
  updateStatus(params) {
    return http.put(API_URLS.GROUP_STATUS, {params});
  },
  getBdInfo(query) {
    return http.get(API_URLS.BD_INFO, {query});
  },
  getMemberRebateList(query) {
    return http.get(API_URLS.MEMBER_REBATE_LIST, {query});
  },
  getProducts(query) {
    return http.get(API_URLS.CFG_PRODUCTS, {query});
  },
  getAllCurrency(query) {
    return http.get(API_URLS.ALL_CURRENCY, {query});
  },
  getPrivacyLang() {
    return http.get(API_URLS.PRIVACY_LANG, {});
  },

  getDashboardSummary(query) {
    return http.get(API_URLS.DASHBOARD_SUMMARY, {query});
  },
  getDashboardTunnel(query) {
    return http.get(API_URLS.DASHBOARD_TUNNEL, {query});
  },
  getTrendClient(query) {
    return http.get(API_URLS.DASHBOARD_TREND_CLIENT, {query});
  },
  getTrendAgent(query) {
    return http.get(API_URLS.DASHBOARD_TREND_AGENT, {query});
  },
  getTrendTrade(query) {
    return http.get(API_URLS.DASHBOARD_TREND_TRADE, {query});
  },
  getTrendRegister(query) {
    return http.get(API_URLS.DASHBOARD_TREND_REGISTER, {query});
  },
  getTrendMembership(query) {
    return http.get(API_URLS.DASHBOARD_TREND_MEMBERSHIP, {query});
  },
  getUserProfile(query) {
    return http.get(API_URLS.USER_PROFILE, {query});
  },
  getShortUrlList(query) {
    return http.get(API_URLS.SHORT_URL_LIST, {query});
  },
  createShortUrl(params) {
    return http.post(API_URLS.SHORT_URL_CREATE, {params});
  },
  deleteShortUrl(id) {
    return http.delete(API_URLS.SHORT_URL_DELETE, {query: {id}});
  },
  getShortUrlDetail(query) {
    return http.get(API_URLS.SHORT_URL_DETAIL, {query});
  },
  getCommissionEquityAmount() {
    return http.get(API_URLS.KOL_COMMISSION_EQUITY_AMOUNT, {});
  },
  getCommissionEquityDetail(pageNum, pageSize) {
    return http.get(API_URLS.KOL_COMMISSION_EQUITY_DETAIL, {query: {pageNum, pageSize}});
  },
  getCommissionEquityPrice(timestamp) {
    return http.get(API_URLS.KOL_COMMISSION_EQUITY_PRICE, {query: {timestamp}});
  },
  getDashboardCommission(query) {
    return http.get(API_URLS.KOL_COMMISSION_SUMMARY, {query});
  },
  getDashboardTradeVolume(query) {
    return http.get(API_URLS.KOL_TRADE_SUMMARY, {query});
  },
  getDashboardReferral(query) {
    return http.get(API_URLS.KOL_REFERRAL_SUMMARY, {query});
  },
  getDashboardDeposit(query) {
    return http.get(API_URLS.KOL_DASHBOARD_DEPOSIT_SUMMARY, {query});
  },
  getDashboardReferralTrade(query) {
    return http.get(API_URLS.KOL_REFERRAL_TRADE_SUMMARY, {query});
  },
  getDashboardWallet() {
    return http.get(API_URLS.KOL_DASHBOARD_WALLET_SUMMARY, {query: {}});
  },
  getDashboardExportData(query) {
    return http.get(API_URLS.KOL_DASHBOARD_EXPORT, {query});
  },
  getSharePageList(lang) {
    return http.get(API_URLS.SHARE_PAGE_LIST, {query: {lang}});
  },
  getDashboardXPTProgress() {
    return http.get(API_URLS.KOL_DASHBOARD_XPT_DISTRIBUTION, {query: {}});
  },
  getDashboardVEPTPhrases() {
    return http.get(API_URLS.KOL_DASHBOARD_VEPT_PHRASES, {query: {}});
  },
  getAgentCommissionRate() {
    return http.get(API_URLS.AGENT_COMMISSION_RATE, {query: {}});
  },
  updateAgentCashbackRate(params) {
    return http.put(API_URLS.AGENT_COMMISSION_RATE, params);
  },
  // broker
  getBrokerApplyInfo() {
    return http.get(API_URLS.BROKER_APPLY_INFO, {query: {}});
  },
  applyForBroker(params) {
    return http.post(API_URLS.BROKER_APPLY, {params});
  },
  getBrokerInfo() {
    return http.get(API_URLS.BROKER_INFO, {query: {}});
  },
  getBrokerDashboardCommission(startTime, endTime, trendResult) {
    return http.get(API_URLS.BROKER_DASHBOARD_COMMISSIONS, {query: {startTime, endTime, trendResult}});
  },
  getBrokerDashboardTradeVolume(startTime, endTime, trendResult) {
    return http.get(API_URLS.BROKER_DASHBOARD_TRADE_VOLUME, {query: {startTime, endTime, trendResult}});
  },
  getBrokerDashboardTraders(startTime, endTime, trendResult) {
    return http.get(API_URLS.BROKER_DASHBOARD_TRADERS, {query: {startTime, endTime, trendResult}});
  },
  getBrokerDashboardWallet() {
    return http.get(API_URLS.BROKER_DASHBOARD_WALLET, {query: {}});
  },
  getBrokerDashboardExportData(startTime, endTime, exportData) {
    return http.get(API_URLS.BROKER_DASHBOARD_EXPORT, {query: {startTime, endTime, exportData}});
  },
  getBrokerTraders(query) {
    return http.get(API_URLS.BROKER_TRADERS, {query});
  },
  getBrokerContractCommissions(query) {
    return http.get(API_URLS.BROKER_CONTRACT_COMMISSIONS, {query});
  },
  getBrokerSpotCommissions(query) {
    return http.get(API_URLS.BROKER_SPOT_COMMISSIONS, {query});
  },
  getBrokerAssetsIssuedList(pageNum, pageSize) {
    return http.get(API_URLS.BROKER_ISSUED_COMMISSIONS, {query: {pageNum, pageSize}});
  },
  getBrokerAssetsIssuedDetails(commissionAt) {
    return http.get(API_URLS.BROKER_ISSUED_COMMISSION_DETAILS, {query: {commissionAt}});
  },
  getBrokerAssetsSummary() {
    return http.get(API_URLS.BROKER_ASSETS_SUMMARY, {query: {}});
  },

  //meme 相关
  getMemeSymbols() {
    return http.get(API_URLS.MEME_SYMBOLS, {query: {}});
  },
  getMemeCurrencies() {
    return http.get(API_URLS.MEME_CURRENCIES, {query: {}});
  },
  queryTradingLeadersCommssion(query) {
    return http.get(API_URLS.KOL_TRADING_LEADERS_COMMSSION_SHARE, {query});
  },
  queryTradingLeadersBotsList(query) {
    return http.get(API_URLS.PARTNER_TRADING_LEADERS_BOTS_SHARE, {query});
  },
};
